let store = {
  state: {
    // 底部导航管理
    tabBar: null
  },
  changeTabBar(tabBar) {
    this.state.tabBar= tabBar
  },

}
export default store

/*
import Vue from 'vue'
import Vuex from 'vuex'

//挂载Vuex
Vue.use(Vuex)

//创建VueX对象
const store = new Vuex.Store({
  state: {
    //存放的键值对就是所要管理的状态
    currentPage: []
  },
  mutations: {
    changePage (state,page) {
      // 变更状态
      state.currentPage=page
    },
    pushPage(state,page){
      state.currentPage.push(page)
    }
  }
})

export default store
*/



// WEBPACK FOOTER //
// ./src/store/index.js